import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useProductsFR } from "../../hooks/product-fr";
import Loading from "../../Components/Common/Loading";
import { Accordion } from "react-bootstrap";
import SEOInputs from "../../Components/PageCard/SEOInputs";
import SectionContainer from "./SectionContainer";
import forms from "./forms";
import { removeDataWrappers } from "../../utils/utils";
import { useTranslation } from "react-i18next";

const ProductFRItemView = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const locale = i18n.language?.includes("en") ? "en" : "fr";
  const [formData, setFormData] = useState({
    ...Object.keys(forms).reduce((acc, key) => ({ ...acc, [key]: {} }), {}),
  });
  const [currentProduct, setCurrentProduct] = useState({});
  const { getOneProduct, fetching } = useProductsFR();
  const params = useParams();

  useEffect(() => {
    if (!currentProduct?.attributes || !locale) return;

    if (!currentProduct?.attributes?.locale?.includes(locale)) {
      const id = currentProduct?.attributes?.localizations?.data[0]?.id;
      navigate(`/products-fr/${id}`);
    }
  }, [locale, currentProduct, navigate]);

  useEffect(() => {
    getOneProduct(params.id).then((data) => {
      setCurrentProduct(data?.data);
      Object.keys(forms).forEach((key) => {
        if (data?.data?.attributes[key]) {
          setFormData((prev) => ({
            ...prev,
            [key]: removeDataWrappers(data?.data?.attributes[key]),
          }));
        }
      });
      setFormData((prev) => ({
        ...prev,
        type: data?.data?.attributes.type,
        collection: data?.data?.attributes.collection,
        file: data?.data?.attributes.file,
        promo: data?.data?.attributes.promo,
        price_value: data?.data?.attributes.price_value,
        promo_amount: data?.data?.attributes.promo_amount,
      }));
    });
  }, [params.id]);

  if (fetching) return <Loading />;
  return (
    <div>
      <Accordion className=" rounded-10">
        <div className="d-flex flex-column gap-3">
          {currentProduct?.attributes?.seo?.data && (
            <SEOInputs
              seo={currentProduct?.attributes?.seo?.data}
              title={currentProduct?.attributes?.name}
              collapsed
            />
          )}
          {Object.entries(forms).map(([key, form], idx) => (
            // TODO YOSRI
            // 1 - ADD TO FORM : promo Bool, promo_amount Number,price_value Number
            // FIELDS ALREADY IN STRAPI
            <SectionContainer
              {...form}
              key={idx}
              formData={formData}
              setFormData={setFormData}
              formKey={key}
              id={params.id}
            />
          ))}
        </div>
      </Accordion>
    </div>
  );
};

export default ProductFRItemView;
